export const WORKSPACE_GOGGLES_QUERY_KEY = ["workspace-goggles"] as const;
